import { useContext, useMemo, useRef, useState } from "react";
import { Alert, Stack } from "react-bootstrap";
import { AlertContext } from "../../pages/login/login";
import "./alert.sass"
export const TOPSTYLEDISTANT = "60";

export const AlertMessage = () => {
  const { alerts } = useContext(AlertContext);
  return (
    <Stack>
      {alerts?.map((a) => (
        <SimpleAlert key={a.id} {...a} />
      ))}
    </Stack>
  );
};

const SimpleAlert = ({ alertText, alertVariant, time, id, darkerVersion}) => {

  const [showAlert, setShowAlert] = useState(true);
  const timer = useRef();
  const { removeAlert } = useContext(AlertContext);

  useMemo(() => {
    if (time) {
      timer.current = setTimeout(() => {
        setShowAlert(() => false);
        removeAlert(id);
      }, time);
    }
  }, []);

  return (
    showAlert && (
      <Alert style={{width: "701px"}} key={id} className={`mainAlert ${darkerVersion ? 'custom-dark': ''}`} variant={alertVariant} onClose={() => setShowAlert(false)} dismissible show={showAlert}>
        <p>{alertText}</p>
      </Alert>
    )
  );
};
